const getClinGenSchemaProperties = (state) =>
  __IS_COMPONENTS_PORTAL__
    ? state?.schema?.properties?.genes?.items?.properties?.clingen_gene
    : state?.schema?.properties?.clingen_gene;

const getClingenData = (state) => {
  return __IS_COMPONENTS_PORTAL__
    ? state.variantResult?.genes?.[state.selectedGeneIndexClinical]
        ?.clingen_gene
    : state?.variantResult?.clingen_gene;
};

export { getClinGenSchemaProperties, getClingenData };
